import { useState, type ReactNode } from 'react'
import type { LeiauteColunas } from '../../hooks/useLeiauteColunas'

// Pecas de tela do leiaute de colunas (hooks/useLeiauteColunas): titulo arrastavel e
// o menu "Colunas" + botao "Gravar leiaute". Usadas em Contas a Pagar/Receber e Inscricoes.

// <th> que se arrasta para mudar a coluna de lugar. A coluna arrastada vai no proprio
// arraste (dataTransfer): ler so o estado do React falhava no soltar.
export function ColunaArrastavel({ id, leiaute, className = '', children }: {
  id: string; leiaute: LeiauteColunas; className?: string; children: ReactNode
}) {
  const { arrastando, setArrastando, mover } = leiaute
  return (
    <th
      data-coluna={id}
      draggable
      title="Arraste para mudar a coluna de lugar"
      onDragStart={e => { setArrastando(id); e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', id) }}
      onDragOver={e => e.preventDefault()}
      onDrop={e => {
        e.preventDefault()
        const de = e.dataTransfer.getData('text/plain') || arrastando
        if (de) mover(de, id)
        setArrastando(null)
      }}
      onDragEnd={() => setArrastando(null)}
      className={`cursor-move select-none ${className} ${arrastando === id ? 'opacity-40' : ''} ${arrastando && arrastando !== id ? 'hover:bg-compumaq-dourado/15' : ''}`}
    >
      {children}
    </th>
  )
}

// Botao "Colunas" (mostrar/esconder, restaurar) + "Gravar leiaute" com aviso de nao gravado.
export function MenuLeiaute({ leiaute, titulos, onAviso }: {
  leiaute: LeiauteColunas
  titulos: Record<string, string>
  onAviso?: (a: { type: 'success' | 'error'; message: string }) => void
}) {
  const [aberto, setAberto] = useState(false)
  async function gravar() {
    const ok = await leiaute.gravar()
    onAviso?.(ok ? { type: 'success', message: 'Leiaute gravado.' } : { type: 'error', message: 'Nao foi possivel gravar o leiaute.' })
    if (ok) setAberto(false)
  }
  return (
    <div className="flex items-center gap-2" data-menu-leiaute>
      {leiaute.naoGravado && <span className="text-xs text-amber-600 whitespace-nowrap" data-aviso-leiaute>leiaute nao gravado</span>}
      <div className="relative">
        <button type="button" onClick={() => setAberto(a => !a)} className="px-3 py-2 border border-compumaq-dourado/40 text-sm rounded-lg hover:bg-compumaq-preto">Colunas</button>
        {aberto && (
          <div data-menu-colunas className="absolute right-0 z-30 mt-1 w-60 bg-compumaq-pretoSuave border border-compumaq-dourado/25 rounded-lg shadow-lg p-3 space-y-1 text-sm">
            <p className="text-xs text-compumaq-textoSuave mb-1">Mostrar colunas (arraste o titulo na tabela para mudar a ordem)</p>
            {leiaute.colunas.map(id => (
              <label key={id} className="flex items-center gap-2">
                <input type="checkbox" aria-label={`Coluna ${titulos[id]}`} checked={!leiaute.ocultas.includes(id)} onChange={() => leiaute.alternar(id)} />
                {titulos[id]}
              </label>
            ))}
            <button type="button" onClick={() => leiaute.restaurar()} className="mt-2 text-xs text-compumaq-doradoClaro underline">Restaurar padrao</button>
          </div>
        )}
      </div>
      <button type="button" onClick={gravar} disabled={leiaute.gravando || !leiaute.naoGravado}
        title={leiaute.naoGravado ? 'Grava a ordem e as colunas escondidas para o seu usuario' : 'Nada para gravar'}
        className="px-3 py-2 text-sm rounded-lg border border-green-600 text-green-700 hover:bg-green-50 disabled:opacity-40 whitespace-nowrap">
        {leiaute.gravando ? 'Gravando...' : 'Gravar leiaute'}
      </button>
    </div>
  )
}
